import { render, staticRenderFns } from "./FeeTrend.vue?vue&type=template&id=c1fbd1c6&scoped=true"
import script from "./FeeTrend.vue?vue&type=script&lang=js"
export * from "./FeeTrend.vue?vue&type=script&lang=js"
import style0 from "./FeeTrend.vue?vue&type=style&index=0&id=c1fbd1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fbd1c6",
  null
  
)

export default component.exports